var map = {
	"./AWSLoad.png": 977,
	"./AWSRG.png": 978,
	"./AWSWorkspace.png": 979,
	"./App.png": 980,
	"./BeanStalk.png": 981,
	"./CD.png": 982,
	"./Cache.png": 983,
	"./Container.png": 984,
	"./DynamoDB.png": 985,
	"./EBS.png": 986,
	"./EC2.png": 987,
	"./ECR.png": 988,
	"./ECS.png": 989,
	"./EFS.png": 990,
	"./EKS.png": 991,
	"./ELasticIP.png": 992,
	"./EMR.png": 993,
	"./FSx.png": 994,
	"./GA.png": 995,
	"./HDCluster.png": 996,
	"./IP.png": 997,
	"./Lambda.png": 998,
	"./Load.png": 999,
	"./MDisk.png": 1000,
	"./RDS.png": 1001,
	"./RG.png": 1002,
	"./Redis.png": 1003,
	"./S3.png": 1004,
	"./S3Glacier.png": 1005,
	"./SBus.png": 1006,
	"./SNS.png": 1007,
	"./SQS.png": 1008,
	"./Sql.png": 1009,
	"./Storage.png": 1010,
	"./TM.png": 1011,
	"./VM.png": 1012,
	"./Workspace.png": 1013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 650;